//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "",
    data(){
        return {
          planA:false, //判断第三方入口
        }
    },
    props:{
      templateFlag:{
        type: String,
        default() { return ''}
      },
      salesVolume:{
        type:Object,
        default (){ return {} }
      },
      socialSecurity:{
        type: Number,
        default() { return 0}
      },
      datailsInfo:{
        type:Object,
        default (){ return {} }
      },
      detailInfo:{
        type:Object,
        default (){ return {} }
      },
    },
    created() {
        if(this.$route.path == '/detailsA'){
            this.planA = true
        }else{
            this.planA = false
        }
    },
    mounted() {

    }
}
